import { Input } from "@/components/ui/input";

export const PaymentInput = ({ value, onChange, options = [], testId, id = "payment-options" }) => (
  <>
    <Input value={value || ""} onChange={(e) => onChange(e.target.value)} list={id} placeholder="Scegli o scrivi la modalità di pagamento" data-testid={testId} />
    <datalist id={id}>{options.map((o) => <option key={o} value={o} />)}</datalist>
  </>
);
